interface IConfig {
  mapbox_api_access_token: string;
}

declare const CONFIG: IConfig;

export const MAPBOX_API_ACCESS_TOKEN = CONFIG.mapbox_api_access_token;
